import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getContactsList: function ({
    limit = 9999,
    page = 1,
    search,
    query = 'sort[]=nickName',
    contactType = 1,
    isPartners = false
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    // const withElastic = `clients?${query}`
    const withoutElastic = `clients/withoutelastic?${query}`
    // let api = search ? withElastic : withoutElastic
    return instCred.get(withoutElastic, {params: {
      'contactType[]': contactType,
      page,
      limit,
      search
    }})
  },
  getClientsSelect ({contactType}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'company': VueCookie.get('company'),
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    const query = []
    if (contactType) query.push(contactType)
    return instCred.get(`clients/getSelect?${query.join('&')}`)
  },
  getClientByPartner (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'company': VueCookie.get('company'),
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get(`clients/getClientByPartner/${id}`)
  },
  getSelectPartner () {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'company': VueCookie.get('company'),
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('clients/getSelectPartner')
  },
  getContactsListPositive: function ({query = ''}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('clients/positive?page=1&limit=1000&' + query)
  },
  getContactsTotals: function () {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('clients/total')
  },
  getContact: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('clients/' + id)
  },
  getContactBalances: function (body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('soa/excel/balances', body)
  },
  createContact: function (contact) {
    contact.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('clients', contact)
  },
  editContact: function (contact, noLogs) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'clientLog': !noLogs
      }
    })
    return instCred.put('clients/' + contact._id, contact)
  },
  editContactByField: function (id, value, noLogs) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'clientLog': !noLogs
      }
    })
    return instCred.put('clients/department/' + id, value)
  },
  getClientByDepartment ({ isContact, isBusiness, contactType }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = []
    if (isContact) query.push(`isContact=${isContact}`)
    if (isBusiness) query.push(`isBusiness=${isBusiness}`)
    if (contactType) query.push(`contactType[]=${contactType}`)
    return instCred.get(`clients/filterDepartment?${query.join('&')}`)
  },
  deleteContact: function (contact) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('clients/' + contact)
  },
  getProjects: function ({clientId}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'company': VueCookie.get('company'),
        'client': clientId,
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('clients/projects')
  },
  editProject: function (project) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'company': VueCookie.get('company'),
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.put('projects/' + project.id, project)
  },
  getBirthdays: function (
    {
      page = 1,
      limit = 50,
      sort,
      birthday,
      search,
      callStatus
    }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'company': VueCookie.get('company'),
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (sort) query.push(`sort[]=${sort}`)
    if (birthday) query.push(`birthday[]=${birthday}`)
    if (callStatus) query.push(`isCongratulate=${callStatus}`)
    if (search) query.push(`search=${search}`)
    const name = search ? 'clients/birthdaylist?' : 'clients/birthdaylist?'
    return instCred.get(name + query.join('&'))
  }
}



// WEBPACK FOOTER //
// ./src/api/Contacts/api.js